<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
#app {
  height: 100vh;
  overflow: auto;
}
</style>
